import React, { useState } from "react";
import ModulesTable from "./ModulesTable";
import BatteryHistoryTable from "./BatteryHistoryTable";
import ActivityTable from "./ActivityTable";

const ContentTabs = ({ modules, showers, heartbeats, batteryHistory, statusLogs, moduleLogs, currentBattery, onRefetch, initialTab = "modules" }) => {
  const [activeTab, setActiveTab] = useState(initialTab && ["modules", "activity", "battery"].includes(initialTab) ? initialTab : "modules");

  const totalActivities = (heartbeats?.length || 0) + (showers?.length || 0) + (statusLogs?.length || 0) + (moduleLogs?.length || 0);

  const tabs = [
    {
      id: "modules",
      label: "Modules installés",
      count: modules?.length || 0,
    },
    {
      id: "activity",
      label: "Activité",
      count: totalActivities,
    },
    {
      id: "battery",
      label: "Historique batterie",
      count: 0,
    },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "modules":
        return <ModulesTable modules={modules} onRefetch={onRefetch} />;
      case "activity":
        return <ActivityTable heartbeats={heartbeats} showers={showers} statusLogs={statusLogs} moduleLogs={moduleLogs} />;
      case "battery":
        return <BatteryHistoryTable batteryHistory={batteryHistory} currentBattery={currentBattery} />;
      default:
        return <ModulesTable modules={modules} onRefetch={onRefetch} />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Navigation des onglets */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                py-2 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors duration-200
                ${activeTab === tab.id ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}
              `}
            >
              {tab.label}
              {tab.count > 0 && <span className="ml-2 bg-gray-100 text-gray-900 py-0.5 px-2.5 rounded-full text-xs">{tab.count}</span>}
            </button>
          ))}
        </nav>
      </div>

      {/* Contenu de l'onglet actif */}
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default ContentTabs;
